import React from 'react';
import { Text, DesktopWrap, UnsavedChangesDiv } from './Notifications.styled';
import Popup from 'src/common/refactoredComponents/popup/Popup';
import AlertCircleOutline from 'src/assets/images/AlertCircleOutline.svg';
import Button from 'src/common/refactoredComponents/button/Button';
import { ButtonStyles } from 'src/constants/buttonStyles';
import { useSelector} from 'react-redux';
import { useTranslation } from 'react-i18next';
  
const NotAbleToReceiveSets = ({
    onClose,
    setNumber,
    batchNumber,
    BulkValidatedData,
    isBulkDchainAdd
}) => {
    const validatedData = useSelector(
        (state) => state.createReceiveSetsReducer.createReceiveSets
    );
    const barcodeDetails = useSelector(
        (state) => state.receiveSetsListDataReducer.barcodeDetails
    );
    const { t } = useTranslation();
    return (
        <>
            <Popup
            id="receivesets-notabletoreceivesets-popup"
                title={t('receiveSets.ReceiveSetsLoc.ScanBardCodePopUp.msg7')}
                onClose={onClose}
                img={AlertCircleOutline}
                id={'receiveSets-notAbleToReceiveSets-popup'}
            >
                <UnsavedChangesDiv divHeight={'140px'}>
                    {(!isBulkDchainAdd ? validatedData.statusCode === '10734' : BulkValidatedData === '10734') ? (
                        <Text
                            // flexGrow={'1'}
                            // height={'auto'}
                            // font={'14px Avenir Next World'}
                            // lineHeight={'20px'}
                        >
                            {t('more.common.templateDetails.set')}{' '}
                            {setNumber ? setNumber : barcodeDetails.setNumber}
                            {'.'}
                            {batchNumber
                                ? batchNumber
                                : barcodeDetails.batchNumber}{' '}
                            {t('receiveSets.ReceiveSetsLoc.NotAbleToReceiveSetsErrorMessage.notAbleToSetsErrorMsg')}
                        </Text>
                    ) : (!isBulkDchainAdd ? validatedData.statusCode === '10830' : BulkValidatedData === '10830') && (
                        <Text>
                             {t('more.common.templateDetails.set')}{' '}
                            {setNumber ? setNumber : barcodeDetails.setNumber}
                            {'.'}
                            {batchNumber
                                ? batchNumber
                                : barcodeDetails.batchNumber}{' '}
                           {t('receiveSets.ReceiveSetsLoc.NotAbleToReceiveSetsErrorMessage.notAbleToSetsErrorMsg1')}
                        </Text>
                    )}

                    <DesktopWrap flexDirection="row-reverse">
                        <Button
                        id={'receiveSets-notifications-notAbleToReceiveSetsOkButton'}
                            show={true}
                            width={'80px'}
                            height={'38px'}
                            //primary={true}
                            variant={ButtonStyles?.primary}
                            // borderRadius={'19px'}
                            margin={'5px 0 5px 5px'}
                            // fontSize={'15px'}
                            // fontFamily={'AvenirNextWorld Demi'}
                            clicked={onClose}
                        >
                            <div style={{ whiteSpace: 'nowrap' }}>{t('ConsignmentAdd.common.feesAndItems.ok')}</div>
                        </Button>
                    </DesktopWrap>
                </UnsavedChangesDiv>
            </Popup>
        </>
    );
};

export default NotAbleToReceiveSets;
